var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInformationB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.a-icon-information-b,.b-icon-information-b,.c-icon-information-b{fill:#3aabf2;}.a-icon-information-b{opacity:0.2;}.c-icon-information-b{stroke:#3aabf2;stroke-width:0.3px;}\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-603 -268)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-352 -25)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a-icon-information-b",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(955 293)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(604.88 271.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.12 8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b-icon-information-b",
    d: "M28.166,10.252A15.909,15.909,0,1,1,12.256,26.161,15.909,15.909,0,0,1,28.166,10.252m0-2.1a18.006,18.006,0,1,1,0,.011Z",
    transform: "translate(-10.12 -8.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c-icon-information-b",
    d: "M26.126,34.825a1.046,1.046,0,0,1-1.046-1.046V22.127a1.052,1.052,0,1,1,2.1,0V33.779a1.046,1.046,0,0,1-1.057,1.046Z",
    transform: "translate(-8.08 -6.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c-icon-information-b",
    cx: 1.683,
    cy: 1.683,
    r: 1.683,
    transform: "translate(16.318 8.829)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformationB);
export default __webpack_public_path__ + "static/media/icon-information_b.86c7b974eadf7c5de576d24dfdfa6ee8.svg";
export { ForwardRef as ReactComponent };